import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { asRem } from 'lib/css';
import { UserContext } from './UserContext';
import { Pages } from './pages';

const TopBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: calc(100% - ${asRem(1)});
  padding: ${asRem(16)} ${asRem(40)};
  background: rgba(10, 10, 12, 0.85);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid #222228;

  @media screen and (max-width: ${asRem(600)}) {
    padding: ${asRem(16)} ${asRem(20)};
  }

  .logo-link {
    display: flex;
    align-items: center;
  }

  .logo {
    height: ${asRem(34)};
    width: auto;
  }

  aside {
    display: flex;
    align-items: center;

    a {
      background: none;
      padding: 0;
      border: none;
    }

    .avatar {
      width: ${asRem(34)};
      height: ${asRem(34)};
      border-radius: 50%;
      border: 2px solid #2a2a32;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img.profile {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }

    .initials {
      background: #1e1e24;
      color: #6b697a;
      font-size: ${asRem(13)};
      font-weight: 600;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const TopBar = () => {
  const userContext = useContext(UserContext);
  const user = userContext?.user;
  const firstName = user?.profile?.first_name || '';
  const lastName = user?.profile?.last_name || '';
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  return (
    <TopBarWrapper>
      <Link to="/" className="logo-link">
        <img src="/rz-logo.svg" alt="Roanuz" className="logo" />
      </Link>
      <aside>
        <Link to={Pages.staff.profile.meta.url}>
          <div className="avatar">
            {user?.profile?.picture_url ? (
              <img className="profile" src={user.profile.picture_url} alt="Profile" />
            ) : (
              <span className="initials">{initials}</span>
            )}
          </div>
        </Link>
      </aside>
    </TopBarWrapper>
  );
};

TopBar.propTypes = {
};
